import React, {useState, useEffect, useRef} from 'react';
import {Button} from "primereact/button";
import {Link} from "react-router-dom";
import {Menubar} from "primereact/menubar";
import {withTranslation} from 'react-i18next';
import {SplitButton} from "primereact/splitbutton";
import {ConfirmDialog} from "primereact/confirmdialog";
import {Badge} from "primereact/badge";
import Cookies from "js-cookie";

import HelpComponent from "./HelpComponent";
import NotificationsComponent from "./NotificationsComponent";
import axios from "axios";
import {closeMercureSubscription, openMercureSubscription} from "../util/mercure";

const NavbarComponent = (props) => {

  const {t, i18n} = props;
  const [menu, setMenu] = useState([]);
  const [profile, setProfile] = useState([]);

  useEffect(() => {
    const topic = process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST.replace('/api', '')
      + Cookies.get("instanceId") + "/new-entity";
    const eventSource = openMercureSubscription({
      topics: [topic],
    });
    if (!eventSource) {
      return undefined;
    }

    console.log('feliratkozás történt: ' + topic)
    eventSource.onmessage = (event) => {
      const data = JSON.parse(event.data);
      console.log('push notification arrived:');
      console.log(data)
      if (data.entity.includes('AccommodationPreparationTaskList')) {
        localStorage.setItem('unreadAccommodationAreparation', data.id)
      }
      if (data.entity.includes('Price')) {
        localStorage.setItem('unreadPrice', data.id)
      }
    }
    return () => {
      closeMercureSubscription(eventSource);
      console.log('leiratkozás történt: ' + topic)
    };
  }, []);

  useEffect(() => {
    if (localStorage.getItem('adminSession') && localStorage.getItem('adminSession') === 'true' &&
      Cookies.get('roles') && Cookies.get('roles').toString().includes('ROLE_SUPER_ADMIN')) {
      let _admin_items = [
        {
          label: t('helps'),
          icon: 'pi pi-question-circle',
          url: '/#/help',
          className: 'master-data'
        },
        {
          label: t('monolog'),
          icon: 'pi pi-list',
          url: '/#/monolog',
          className: 'master-data'
        },
        {
          label: t('auditlog'),
          icon: 'pi pi-list',
          url: '/#/auditlog',
          className: 'master-data'
        },
        {
          label: t('registrations'),
          icon: 'pi pi-users',
          url: '/#/registrations',
          className: 'master-data'
        },
        {
          label: t('notifications'),
          icon: 'pi pi-bell',
          url: '/#/notification',
          className: 'master-data'
        },
        {
          label: t('zipcodes'),
          icon: 'pi pi-map',
          url: '/#/zipcode',
          className: 'master-data'
        },
        {
          label: t('guest_information_request_recommendations'),
          icon: 'pi pi-list',
          url: '/#/girp-additional-field-collection',
          className: 'master-data'
        },

      ]
      if (process.env.REACT_APP_BRAND === 'felhomatrac') {
        _admin_items.push(
          {
            label: t('vatgroups'),
            icon: 'pi pi-percentage',
            url: '/#/admin-vatgroup',
            className: 'master-data'
          },
          {
            label: t('subscriptionplans'),
            icon: 'pi pi-history',
            url: '/#/subscriptionplan',
            className: 'master-data'
          },
        )
      }
      setMenu(_admin_items)
      let _profile = [
        {
          label: t('profile'),
          icon: 'pi pi-user',
          command: () => {
            window.App.setState({
              sidebarPaycenterForm: false,
              sidebarSubscriptionForm: false,
              sidebarProfileForm: true
            })

          }
        },
        {
          label: t('users'),
          icon: 'pi pi-users',
          command: () => {
            window.location.replace('/#/user');
            window.App.forceUpdate()
          }
        },
        {
          label: t('logout'),
          icon: 'pi pi-sign-out',
          command: () => {
            window.App.setState({confirmLogout: true})
          }
        },
      ]
      setProfile(_profile)
    } else {
      let _menu = [
        {
          label: t('control_panel'),
          icon: 'pi pi-sliders-v',
          url: '/#/control-panel',
          className: 'control-panel'
        }
      ]
      if (process.env.REACT_APP_BRAND === 'felhomatrac') {
        _menu.push(
          // {
          //   label: t('calendar'),
          //   icon: 'pi pi-calendar',
          //   url: '/#/calendar',
          //   className: '_FM_calendar'
          // },
          {
            label: t('reservations'),
            icon: 'pi pi-check-square',
            className: '_FM_reservation',
            items: [
              {
                label: t('reservations'),
                icon: 'pi pi-check-square',
                url: '/#/reservation',
                className: '_FM_master-data'
              },
              {
                label: t('calendar'),
                icon: 'pi pi-calendar',
                url: '/#/calendar',
                className: '_FM_calendar'
              },
              {
                label: t('groups'),
                icon: 'pi pi-users',
                url: '/#/group',
                className: '_FM_group  p-d-none p-d-xl-block',
              },
            ]
          },
          {
            label: t('master_data'),
            icon: 'pi pi-box',
            className: '_FM_master-data',
            id: 'master-data',
            items: [
              {
                label: t('services'),
                icon: 'pi pi-box',
                url: '/#/service',
                className: '_FM_master-data'
              },
              // {
              //   label: t('partners'),
              //   icon: 'pi pi-user',
              //   url: '/#/partner',
              //   className: 'partner'
              // },
              {
                label: t('guests'),
                icon: 'pi pi-users',
                url: '/#/guest',
                className: 'guest'
              },
              // {
              //   label: t('customers'),
              //   icon: 'pi pi-users',
              //   url: '/#/customer',
              //   className: 'customer'
              // },
              // {
              //   label: t('guestinforequest'),
              //   icon: 'pi pi-table',
              //   url: '/#/guestinforequest',
              //   className: '_FM_master-data'
              // },
              {
                separator: true,
                template: () => <div className="p-menu-separator"></div>
              },
              {
                label: t('reservation_channels'),
                icon: 'pi pi-filter',
                url: '/#/channel',
                className: '_FM_master-data'
              },
              {
                label: t('channel_manager'),
                icon: 'pi pi-filter',
                url: '/#/ezee',
                className: '_FM_master-data'
              },
              {
                separator: true,
                template: () => <div className="p-menu-separator"></div>
              },
              {
                label: t('builder'),
                icon: 'pi pi-sitemap',
                url: '/#/builder',
                className: '_FM_master-data p-d-none p-d-xl-block'
              },
              {
                label: t('rescategories'),
                icon: 'pi pi-star',
                url: '/#/category',
                className: '_FM_master-data'
              },
              {
                label: t('units'),
                icon: 'pi pi-home',
                url: '/#/unit',
                className: '_FM_master-data'
              },
              {
                label: t('berths'),
                icon: 'pi pi-inbox',
                url: '/#/berth',
                className: '_FM_master-data'
              },
              {
                label: t('ooo_accommodations'),
                icon: 'pi pi-calendar-times',
                url: '/#/oooaccommodation',
                className: '_FM_master-data'
              },
              {
                label: t('ooo_units'),
                icon: 'pi pi-stop-circle',
                url: '/#/ooounit',
                className: '_FM_master-data'
              },
              {
                label: t('ooo_berths'),
                icon: 'pi pi-times-circle',
                url: '/#/oooberth',
                className: '_FM_master-data'
              },
              // {
              //   label: t('accommodationchecklist'),
              //   icon: 'pi pi-clone',
              //   url: '/#/accommodation-readiness-checklist',
              //   className: '_FM_master-data'
              // },
              {
                separator: true,
                template: () => <div className="p-menu-separator"></div>
              },
              // {
              //   label: t('payment_methods'),
              //   icon: 'pi pi-credit-card',
              //   url: '/#/payment-method',
              //   className: '_FM_master-data'
              // },
              // {
              //   label: t('vatgroups'),
              //   icon: 'pi pi-percentage',
              //   url: '/#/vat-group',
              //   className: '_FM_master-data'
              // },
              // {
              //   label: t('currencies'),
              //   icon: 'pi pi-money-bill',
              //   url: '/#/currency',
              //   className: '_FM_master-data'
              // },
              // {
              //   separator: true,
              //   template: () => <div className="p-menu-separator"></div>
              // },
              {
                label: t('prices'),
                icon: 'pi pi-dollar',
                url: '/#/price',
                className: '_FM_master-data',
                template: () => <a className={"p-menuitem-link"} style={{cursor: "pointer"}} onClick={() => {
                  localStorage.removeItem('unreadPrice')
                  window.location.replace('/#/price')
                  document.getElementById('master-data').getElementsByClassName('p-menuitem-link')[0].click()
                }}>
                  <span className={"p-menuitem-icon pi pi-dollar"}></span>
                  <span className={"p-menuitem-text"}>{t('prices')}</span>
                  {localStorage.getItem('unreadPrice') &&
                    <Badge severity="info" className={"p-ml-2"} style={{
                      height: '8px',
                      width: '8px',
                      minWidth: '8px',
                      position: 'relative',
                      left: '-2px',
                      top: '-5px'
                    }}></Badge>
                  }
                </a>,
              },
              {
                label: t('pricecategories'),
                icon: 'pi pi-star',
                url: '/#/price-category',
                className: '_FM_master-data'
              },
              {
                separator: true,
                template: () => <div className="p-menu-separator"></div>
              },
              {
                label: t('folios'),
                icon: 'pi pi-wallet',
                url: '/#/folio',
                className: '_FM_master-data'
              },
              // {
              //   label: t('receipts'),
              //   icon: 'pi pi-file',
              //   url: '/#/receipt',
              //   className: '_FM_master-data'
              // },
            ]
          },
          // {
          //   label: t('accommodationpreparation'),
          //   icon: 'pi pi-check-square',
          //   url: '/#/accommodation-preparation',
          //   className: '_FM_accommodation-preparation',
          //   id: 'accommodation-preparation',
          //   template: () => <a className={"p-menuitem-link"} style={{cursor: "pointer"}} onClick={() => {
          //     localStorage.removeItem('unreadAccommodationAreparation')
          //     window.location.replace('/#/accommodation-preparation')
          //   }}>
          //     <span className={"p-menuitem-icon pi pi-box"}></span>
          //     <span className={"p-menuitem-text"}>{t('accommodationpreparation')}</span>
          //     {localStorage.getItem('unreadAccommodationAreparation') &&
          //       <Badge severity="info" className={"p-ml-2"} style={{
          //         height: '8px',
          //         width: '8px',
          //         minWidth: '8px',
          //         position: 'absolute',
          //         right: '3px',
          //         top: '3px'
          //       }}></Badge>
          //     }
          //   </a>
          // },
        )
      }
      setMenu(_menu)
      let _profile = []
      if (process.env.REACT_APP_BRAND === 'felhomatrac') {
        _profile.push(
          {
            label: t('operators'),
            icon: 'pi pi-briefcase',
            command: () => {
              window.location.replace('/#/operator');
              window.App.forceUpdate()
            }
          },
          {
            label: t('accommodations'),
            icon: 'pi pi-home',
            command: () => {
              window.location.replace('/#/accommodation');
              window.App.forceUpdate()
            }
          },
          {
            label: t('partners'),
            icon: 'pi pi-user',
            command: () => {
              window.location.replace('/#/partner');
              window.App.forceUpdate()
            }
          },
          {
            label: t('payment_methods'),
            icon: 'pi pi pi-credit-card',
            command: () => {
              window.location.replace('/#/payment-method');
              window.App.forceUpdate()
            }
          },
          // {
          //   label: t('paycenter_online_payment'),
          //   icon: 'pi pi pi-credit-card',
          //   command: () => {
          //     window.App.setState({
          //       sidebarProfileForm: false,
          //       sidebarSubscriptionForm: false,
          //       sidebarPaycenterForm: true
          //     })
          //   }
          // },
          {
            label: t('vatgroups'),
            icon: 'pi pi pi-percentage',
            command: () => {
              window.location.replace('/#/vat-group');
              window.App.forceUpdate()
            }
          },
          {
            label: t('currencies'),
            icon: 'pi pi pi-money-bill',
            command: () => {
              window.location.replace('/#/currency');
              window.App.forceUpdate()
            }
          },
          {
            label: t('guestinforequest'),
            icon: 'pi pi-table',
            command: () => {
              window.location.replace('/#/guest-information-request-page');
              window.App.forceUpdate()
            }
          },
          {
            label: t('customers'),
            icon: 'pi pi-users',
            command: () => {
              window.location.replace('/#/customer');
              window.App.forceUpdate()
            }
          },
          // {
          //   label: t('accommodationchecklist'),
          //   icon: 'pi pi-clone',
          //   command: () => {
          //     window.location.replace('/#/accommodation-readiness-checklist');
          //     window.App.forceUpdate()
          //   }
          // },
          {
            label: t('receipts'),
            icon: 'pi pi-file',
            command: () => {
              window.location.replace('/#/receipt');
              window.App.forceUpdate()
            }
          },
          {
            separator: true,
            template: () => <div className="p-menu-separator"></div>
          },
          // {
          //   label: t('settings'),
          //   icon: 'pi pi-cog',
          //   command: () => {
          //     window.location.replace('/#/settings');
          //     window.App.forceUpdate()
          //   }
          // },
          {
            label: t('profile'),
            icon: 'pi pi-user',
            command: () => {
              window.App.setState({
                sidebarPaycenterForm: false,
                sidebarSubscriptionForm: false,
                sidebarProfileForm: true
              })
            }
          },
          {
            label: t('users'),
            icon: 'pi pi-users',
            command: () => {
              window.location.replace('/#/user');
              window.App.forceUpdate()
            }
          },
          {
            label: t('subscription'),
            icon: 'pi pi-history',
            command: () => {
              window.App.setState({
                sidebarPaycenterForm: false,
                sidebarProfileForm: false,
                sidebarSubscriptionForm: true
              })
            }
          },
          {
            separator: true,
            template: () => <div className="p-menu-separator"></div>
          },
          {
            label: t('logout'),
            icon: 'pi pi-sign-out',
            command: () => {
              window.App.setState({confirmLogout: true})
            }
          }
        )

      }
      setProfile(_profile)
    }
  }, [localStorage.getItem('adminSession'), window.App.state.rerenderNavbar])

  return (
    <nav>
      <>
        <ConfirmDialog group="declarative" visible={window.App.state.confirmLogout}
                       onHide={() => {
                         window.App.setState({confirmLogout: false})
                       }}
                       acceptLabel={t('yes')} rejectLabel={t('no')}
                       message={t('confirm_logout')} header={t('logout')} icon="pi pi-exclamation-triangle"
                       accept={() => {
                         window.App.logout()
                       }}
                       reject={() => {
                         window.App.setState({confirmLogout: false})
                       }}/>
        <Menubar
          style={{minHeight: '52px'}}
          start={
            <>
              <Link to={"/"}>
                {(!localStorage.getItem('adminSession') || localStorage.getItem('adminSession') === 'false' ||
                    !Cookies.get('roles').toString().includes('ROLE_SUPER_ADMIN')) &&
                  <Badge value={Cookies.get("instanceName")} severity="info"></Badge>
                }
                {(localStorage.getItem('adminSession') && localStorage.getItem('adminSession') === 'true')
                  && Cookies.get('roles') && Cookies.get('roles').toString().includes('ROLE_SUPER_ADMIN') &&
                  <Badge value={"ENGINE ROOM"} severity="danger"></Badge>
                }
              </Link>
            </>
          }
          model={menu}
          className={"p-py-0 p-px-4"}
          end={
            <>
              <HelpComponent type={"global"} position={"UNDER_HELP_BUTTON"}/>
              {(Cookies.get('roles') && Cookies.get('roles').toString().includes('ROLE_SUPER_ADMIN')) &&
                <>
                  {(localStorage.getItem('adminSession') && localStorage.getItem('adminSession') === 'true') &&
                    <>
                      <Button type="button" className="p-button-danger p-ml-2" icon={"pi pi-star-fill"}
                              onClick={() => {
                                localStorage.setItem('adminSession', 'false')
                                document.getElementById('body').classList.remove('admin')
                                window.location.replace('/#/');
                                window.App.forceUpdate()
                              }}/>
                    </>
                  }
                  {(!localStorage.getItem('adminSession') || localStorage.getItem('adminSession') === 'false') &&
                    <span className={"p-d-none p-d-lg-inline"}>
                      <Button type="button" className="p-button-danger p-ml-2" icon={"pi pi-star"}
                              onClick={() => {
                                localStorage.setItem('adminSession', 'true')
                                document.getElementById('body').classList.add('admin')
                                window.location.replace('/#/');
                                window.App.forceUpdate()
                              }}/>
                    </span>
                  }
                </>
              }
              {!window.location.href.includes('#/public-checkin') && !window.location.href.includes('#/fast-checkin') &&
                <NotificationsComponent/>
              }
              <SplitButton label={t('profile')}
                           id="buttonProfile"
                           onClick={() => {
                             document.getElementById('buttonProfile').getElementsByClassName('p-splitbutton-menubutton')[0].click()
                           }}
                           icon="pi pi-user"
                           className={"p-button-success p-ml-2"}
                           model={profile}/>
            </>
          }
        />
      </>
      <HelpComponent type={"global"} position={"TOP_OF_THE_PAGE"}/>
    </nav>
  )
}
export default withTranslation('common')(NavbarComponent);
